import { gql } from 'apollo-boost';

export const DELETE_READING_BOOK_MUTATION = gql`
    mutation deleteReadingBookFromStudent(
        $readingBookId: ID!
        $studentId: ID!
    ) {
        deleteReadingBookFromStudent(
            readingBookId: $readingBookId
            studentId: $studentId
        ) {
            deleted
            errors
        }
    }
`;

export const CHILD_READING_BOOKS = gql`
    query child($childId: ID!) {
        child(childId: $childId) {
            student {
                id
                availableGems
                avatarJson
                boomerAvatarUrl
                updatedAt
                firstName
                lastName
                storeCode
                loginCode
                inactiveSchools {
                    id
                    name
                }
                school {
                    id
                    guideUrl
                    name
                    schoolCode
                    allowParentsGroupLogs
                }
                classes {
                    id
                    name
                    teachers {
                        id
                        displayName
                    }
                    books {
                        id
                        bookCode
                        status
                        title
                        isSingleChapter
                        chapters {
                            id
                            status
                        }
                        currentChapter
                        bookTemplate {
                            id
                            name
                            coverUrl
                            isPromo
                        }
                        studentsClass {
                            id
                            school {
                                id
                                name
                            }
                        }
                    }
                }
                readingBooks {
                    addedBy {
                        displayName
                        id
                    }
                    book {
                        id
                        author
                        coverUrl
                        title
                        isbn
                        isbn13
                        publisher {
                            id
                            name
                        }
                        reviews {
                            id
                            author {
                                id
                            }
                            reviewText
                            reviewRate
                            date
                        }
                    }
                    bookType
                    completedAt
                    hideComments
                    isReread
                    id
                    logs {
                        id
                        author {
                            id
                            firstName
                            lastName
                            displayName
                            role
                        }
                        problemWords {
                            id
                            word
                        }
                        isCompletion
                        date
                        entry
                        pageEnd
                        pageStart
                        readingDate
                    }
                    noReview
                    status
                }
                groupReadingBooks {
                    id
                    status
                    createdAt
                    addedBy {
                        displayName
                        id
                    }
                    book {
                        id
                        title
                    }
                    mostRecentLog {
                        id
                        date
                    }
                    completedAt
                    hideComments
                    students {
                        id
                    }
                }
            }
        }
    }
`;
